// extracted by mini-css-extract-plugin
export var alternate = "_1n-h";
export var black = "_1n-3";
export var blue = "_1n-d";
export var blueLight = "_1n-c";
export var brand = "_1n-7";
export var error = "_1n-9";
export var gray = "_1n-6";
export var grayBlue = "_1n-b";
export var iconWrapper = "_1n-4";
export var indigo = "_1n-e";
export var orange = "_1n-g";
export var pink = "_1n-f";
export var primary = "_1n-0";
export var purple = "_1n-8";
export var success = "_1n-5";
export var warning = "_1n-a";
export var white = "_1n-1";
export var whiteSuccess = "_1n-2";